import { FC, useMemo } from 'react';
import { usePhrases } from '@/entities/phrases';
import { usePhrasePlaybackScope } from '@/features/phrase-playback';
import { PageContainer } from '@/shared/ui';
import { useAudioAuditState } from './model/useAudioAuditState';
import { AudioAuditTable } from './ui/AudioAuditTable';

/**
 * Контейнер раздела «Аудит аудио»: держит окно, отбор и порядок перечня реплик,
 * запрашивает очередную страницу и отдаёт её презентеру.
 */
export const AudioAuditPage: FC = () => {
  const { page, pageSize, sorting, filters, params, ...actions } = useAudioAuditState();
  const { data, isLoading } = usePhrases(params);

  // Прослушивание живёт в пределах одного состава перечня: смена страницы, отбора или порядка,
  // как и уход из раздела, прекращают звучание
  const scopeKey = useMemo(() => JSON.stringify(params), [params]);
  usePhrasePlaybackScope(scopeKey);

  return (
    // Перечень занимает всю ширину рабочей области — как список диалогов
    <PageContainer enableScroll={false} limitedWidth={false} className="flex flex-col gap-4 h-full w-full">
      <AudioAuditTable
        phrases={data?.items ?? []}
        totalCount={data?.total ?? 0}
        page={page}
        pageSize={pageSize}
        sorting={sorting}
        filters={filters}
        isLoading={isLoading}
        onPageChange={actions.onPageChange}
        onPageSizeChange={actions.onPageSizeChange}
        onSortingChange={actions.onSortingChange}
        onFiltersChange={actions.onFiltersChange}
      />
    </PageContainer>
  );
};
